export interface GetNeighborhoodListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetNeighborhoodListPagingAndFilterResponseData
}

export interface GetNeighborhoodListPagingAndFilterResponseData {
    items: GetNeighborhoodListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetNeighborhoodListPagingAndFilterResponseItem {
    neighborhoodId: string
    code: string
    name: string
    countryId: any
    countryName: any
    countyId: string
    countyName: string
    districtId: string
    districtName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetNeighborhoodListPagingAndFilterResponseData: GetNeighborhoodListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}